@if (content.errors.length) {
  <div id="payment-error-summary" role="alert" aria-live="assertive" tabindex="-1">
    <nsc-card [error]="true">
      <nsc-card-title-error title="{{ content.errorTitle }}" icon="warning">
        <p>
          {{content.errorBody}}
        </p>
      </nsc-card-title-error>
      <!-- <nsc-card-content>
      <div >
      </div>
    </nsc-card-content> -->
  </nsc-card>
  <nsc-spacer size="sm"></nsc-spacer>
</div>
}
<form id="form" [formGroup]="formGroup">
  <nsc-card>
    <nsc-card-title note="All fields required, unless otherwise indicated">Payment Details</nsc-card-title>
    <nsc-card-content>
      <div class="row">
        <div class="col-12">

          <h3 class="mat-body-2 mat-hint payment-margin-bottom">Accepted Credit Cards:</h3>
          <br />
          <ul class="nsc-listitem">
            <li>
              <img class="cc-icon" src="/assets/credit-card-logo--visa.png" alt="Visa">
            </li>

            <li>
              <img class="cc-icon" src="/assets/credit-card-logo--mastercard.png" alt="Mastercard">
            </li>

            <li>
              <img class="cc-icon" src="/assets/credit-card-logo--amex.png" alt="American Express">
            </li>

            <li>
              <img class="cc-icon" src="/assets/credit-card-logo--discover.png" alt="Discover">
            </li>
          </ul>

          <nsc-spacer size="sm"></nsc-spacer>
        </div>

        <div class="col-12 col-md-4 payment-fields_wrapper">
          <label id="card-name-label" class="card-name-label" for="card-name">Card Holder Name</label>
          <input maxlength="100" class="card-holder-name payment-fields"
                 id="card-name"
                 type="text"
                 [(ngModel)]="cardHolderName"
                 placeholder="Card Holder Name"
                 required
                 autocomplete="cc-name"
                 aria-required="true"
                 aria-describedby="card-name-errors"
                 [ngModelOptions]="{standalone: true}" />
          <div>
            <span id="card-name-errors" class="input-errors nsc-error invalid" role="alert" aria-live="assertive" aria-atomic="true"></span>
          </div>
        </div>
        <div class="col-12 col-md-4 payment-fields_wrapper">
          <label id="card-number-label" class="card-number-label">Card Number</label>
          <div id="card-number"
               class="form-controls payment-fields"
               role="group"
               aria-labelledby="card-number-label"
               aria-describedby="card-number-errors"></div>
          <div>
            <span id="card-number-errors" class="input-errors nsc-error invalid" role="alert" aria-live="assertive" aria-atomic="true"></span>
          </div>
        </div>
        <div class="col-12 col-md-4"></div>
        <div class="form-row col-12 col-md-4">
          <label id="card-date-label" class="card-date-label">Expiration Date</label>
          <div id="card-date"
               class="form-controls payment-fields"
               role="group"
               aria-labelledby="card-date-label"
               aria-describedby="card-date-errors"></div>
          <div>
            <span id="card-date-errors" class="input-errors nsc-error invalid" role="alert" aria-live="assertive" aria-atomic="true"></span>
          </div>
        </div>
        <div class="form-row col-12 col-md-4 ">
          <label id="card-cvv-label" class="card-cvv-label">CVV</label>
          <div id="card-cvv"
               class="form-controls payment-fields"
               role="group"
               aria-labelledby="card-cvv-label"
               aria-describedby="card-cvv-errors"></div>
          <div>
            <span id="card-cvv-errors" class="input-errors nsc-error invalid" role="alert" aria-live="assertive" aria-atomic="true"></span>
          </div>
        </div>
        <div class="col-12 col-md-4"></div>
        <div class="form-row col-12 col-md-4 ">
          <label id="card-postal-code-label" class="card-postal-code-label">Zip/Postal Code</label>
          <div id="card-postal-code"
               class="form-controls payment-fields"
               role="group"
               aria-labelledby="card-postal-code-label"
               aria-describedby="card-postal-code-errors"></div>
          <div>
            <span id="card-postal-code-errors" class="input-errors nsc-error invalid" role="alert" aria-live="assertive" aria-atomic="true"></span>
          </div>
        </div>
        <div class="col-12 col-md-8"></div>


        <div class="col-12 col-md-8">
          <nsc-form-field-toggle idx="use_contactinfo" controlName="useContactInfo"
            label="Do you want to use your contact address as your billing address?" [group]="formGroup">
          </nsc-form-field-toggle>
        </div>

        <div class="col-12 col-md-8">
          <nsc-form-field-input autocomplete="shipping address-line1" controlName="addressLine1" idx="addressLine1"
            hint="Street number and name or PO Box" maxlength="30" placeholder="Address 1" [group]="formGroup">
          </nsc-form-field-input>
        </div>

        <div class="col-12 col-md-8">
          <nsc-form-field-input autocomplete="shipping address-line2" controlName="addressLine2" idx="addressLine2"
            hint="Building, campus box, floor, apt, suite" maxlength="30" placeholder="Address 2" [group]="formGroup"
          [required]="false"></nsc-form-field-input>
        </div>
        <div class="col-12 col-md-4">
        </div>

        <div class="col-12 col-md-4">
          <nsc-form-field-input autocomplete="shipping address-level2" controlName="city" maxlength="30" idx="city"
          placeholder="City" [group]="formGroup"></nsc-form-field-input>
        </div>
        <div class="col-12 col-md-4">
          <nsc-form-field-select-optgroup controlName="state" placeholder="{{ content.labelState }}" idx="state" [group]="formGroup"
          [selectObjects]="values.states$.value"></nsc-form-field-select-optgroup>
        </div>

        <div class="col-12 col-md-4">
        </div>
        <div class="col-6 col-md-4">
          <nsc-form-field-input autocomplete="shipping postal-code" idx="zipCode" controlName="zip" hint="{{ content.hintZip }}"
          maxlength="15" placeholder="Zip/Postal Code" [group]="formGroup"></nsc-form-field-input>
        </div>
        <div class="col-6 col-md-4">
          <nsc-form-field-select controlName="country" placeholder="Country" [group]="formGroup" idx="country"
          [selectObjects]="values.countries$.value"></nsc-form-field-select>
        </div>

        <div class="col-12">
          <div class="mat-caption">
            Selecting 'Submit Order' will transmit your payment information to
            <a href="https://www.clover.com/" rel="noopener noreferrer" target="_blank" id="FirstDataCorp"
            aria-label="Clover (opens in new window)">Clover<span class="visually-hidden"> (opens in new window)</span></a>,
            a third party payment processing provider. Clover will only share your name, address, or e-mail address
            with National Student Clearinghouse.
          </div>
        </div>
      </div>
    </nsc-card-content>
  </nsc-card>

  <nsc-spacer size="sm"></nsc-spacer>
  <div class="col-12" style="text-align: center;">
    <p class="nsc_total_fee">
      <strong> Total Fees for Order: {{ content.totalFees | currency }} </strong>
    </p>
  </div>

  <nsc-spacer size="sm"></nsc-spacer>



  <div class="nsc-form-actions">

    <button mat-stroked-button id="orderpayment_cancel" class="nsc-form-actions__button button-big" color="primary" type="button"
    (click)="cancel()">Cancel Order</button>
    <nsc-spacer horizontal="true" size="sm"></nsc-spacer>

    <button
      id="orderpayment_submitorder"
      mat-raised-button
      class="nsc-form-actions__button nsc-btn__right button-big"
      color="primary"
      type="button"
      [disabled]="!allFieldsValid"
      data-submit-btn
      (click)="submitPayment()">
      Submit Order @if (allFieldsValid) {
        <mat-icon aria-hidden="true">chevron_right</mat-icon>
      }
    </button>
</div>

</form>
